import * as THREE from 'three';

export default class Environment {
  constructor(experience) {
    this.experience = experience;
    this.scene = this.experience.scene;

    this.setLights();
    this.setFloor();
    this.setFog();
  }

  setLights() {
    // 1. Soft Ambient Fill for subtle base visibility
    this.hemiLight = new THREE.HemisphereLight('#3b4252', '#000000', 0.85);
    this.hemiLight.position.set(0, 20, 0);
    this.scene.add(this.hemiLight);

    // 2. Studio Key Light with crisp shadows
    this.keyLight = new THREE.DirectionalLight('#ffffff', 3.0);
    this.keyLight.position.set(4.5, 8, 5.5);
    this.keyLight.castShadow = true;
    this.keyLight.shadow.mapSize.width = 2048;
    this.keyLight.shadow.mapSize.height = 2048;
    this.keyLight.shadow.camera.near = 0.5;
    this.keyLight.shadow.camera.far = 25;
    this.keyLight.shadow.camera.left = -5;
    this.keyLight.shadow.camera.right = 5;
    this.keyLight.shadow.camera.top = 5;
    this.keyLight.shadow.camera.bottom = -5;
    this.keyLight.shadow.bias = -0.0005;
    this.keyLight.shadow.normalBias = 0.02;
    this.scene.add(this.keyLight);

    // 3. Crisp Rim Light 1 (Right back contour)
    this.rimLightRight = new THREE.DirectionalLight('#7dd3fc', 3.2);
    this.rimLightRight.position.set(4, 3, -4);
    this.scene.add(this.rimLightRight);

    // 4. Crisp Rim Light 2 (Left back contour for symmetrical voxel edge separation)
    this.rimLightLeft = new THREE.DirectionalLight('#93c5fd', 2.2);
    this.rimLightLeft.position.set(-4, 3, -4);
    this.scene.add(this.rimLightLeft);

    // 5. Subtle Top-Down Rim Light
    this.topLight = new THREE.DirectionalLight('#ffffff', 1.8);
    this.topLight.position.set(0, 7, -2);
    this.scene.add(this.topLight);
  }

  setFloor() {
    const floorGeometry = new THREE.PlaneGeometry(40, 40);
    const floorMaterial = new THREE.ShadowMaterial({
      opacity: 0.55
    });

    this.floor = new THREE.Mesh(floorGeometry, floorMaterial);
    this.floor.rotation.x = -Math.PI * 0.5;
    this.floor.position.y = -2.2;
    this.floor.receiveShadow = true;
    this.scene.add(this.floor);
  }

  setFog() {
    this.fog = new THREE.FogExp2('#000000', 0.015);
    this.scene.fog = this.fog;
  }

  setTheme(isDark) {
    if (isDark) {
      this.hemiLight.color.set('#3b4252');
      this.hemiLight.groundColor.set('#000000');
      this.hemiLight.intensity = 0.85;

      this.keyLight.color.set('#ffffff');
      this.keyLight.intensity = 3.0;

      this.rimLightRight.intensity = 3.2;
      this.rimLightLeft.intensity = 2.2;
      this.topLight.intensity = 1.8;

      this.floor.material.opacity = 0.55;
      this.fog.color.set('#000000');
    } else {
      // Light Mode: Clean, crisp studio lighting without overexposure or blowout
      this.hemiLight.color.set('#ffffff');
      this.hemiLight.groundColor.set('#d8d6cf');
      this.hemiLight.intensity = 0.55;

      this.keyLight.color.set('#ffffff');
      this.keyLight.intensity = 1.35;

      this.rimLightRight.intensity = 0.5;
      this.rimLightLeft.intensity = 0.4;
      this.topLight.intensity = 0.35;

      this.floor.material.opacity = 0.08;
      this.fog.color.set('#f5f4ef');
    }
  }
}
